import { GameManager } from "../../GameManager";
import { Button } from "../../utils/Utils";
import { GameConstants } from "../../GameConstants";
import { GameVars } from "../../GameVars";
import { DevLevelButton } from "./DevLevelButton";

export class LevelSelectionScene extends Phaser.Scene {

    public static currentInstance: LevelSelectionScene;
    
    private levelsRail: Phaser.GameObjects.Container;
    private titleLabel: Phaser.GameObjects.Text;

    constructor() {

        super("LevelSelectionScene");
        
        LevelSelectionScene.currentInstance = this;
    }

    public create(): void {

        GameManager.setCurrentScene(this);

        const background = this.add.image(GameConstants.GAME_WIDTH / 2, GameConstants.GAME_HEIGHT * .45, "background");
        background.scaleY = GameVars.scaleY;

        this.levelsRail = this.add.container(0, 0);
        this.levelsRail.scaleY = GameVars.scaleY;

        const titleBackground = this.add.graphics();
        titleBackground.fillStyle(0xFF0FFF);
        titleBackground.setAlpha(.15);
        titleBackground.fillRect(0, 0, GameConstants.GAME_WIDTH, 120 * GameVars.scaleY);
        titleBackground.setInteractive();
        titleBackground.on("pointerdown", function(): void {
        }, this);

        this.titleLabel = this.add.text(GameConstants.GAME_WIDTH / 2, 30 * GameVars.scaleY, "LEVEL SELECTION",{ fontFamily: "Oswald-DemiBold", fontSize: "50px", color: "#FFF900"});
        this.titleLabel.originX = .5;
        this.titleLabel.scaleY = GameVars.scaleY;
        this.titleLabel.setShadow(1, 1, "#38536f", .5);

        let n: number;
        for (let i = 0; i < 10; i++) {
            for (let j = 0; j < 18; j++) {

                n = 10 * j + i;

                if (n <=  25) {
                    let btn = new DevLevelButton(this, n, 1);
                    btn.x = GameConstants.GAME_WIDTH / 2 + (i - 4.5) * 60;
                    btn.y = (240 + 50 * j) / GameVars.scaleY;
                    this.levelsRail.add(btn);
                }
            }
        }

        const breakableBlocksLabel = this.add.text(GameConstants.GAME_WIDTH * 0.5, 180 * GameVars.scaleY, "Breakable Blocks",{ fontFamily: "Oswald-DemiBold", fontSize: "40px", color: "#FFF900"});
        breakableBlocksLabel.setOrigin(0.5);
        breakableBlocksLabel.scaleY = GameVars.scaleY;


        this.levelsRail.add(breakableBlocksLabel);

        for (let i = 0; i < 10; i++) {
            for (let j = 0; j < 18; j++) {

                n = 10 * j + i;

                if (n <=  25) {
                    let btn = new DevLevelButton(this, n, 2);
                    btn.x = GameConstants.GAME_WIDTH / 2 + (i - 4.5) * 60;
                    btn.y = (515 + 50 * j) / GameVars.scaleY;
                    this.levelsRail.add(btn);
                }
            }
        }

        const unBreakableBlocksLabel = this.add.text(GameConstants.GAME_WIDTH * 0.5, 455 * GameVars.scaleY, "Unbreakable Blocks",{ fontFamily: "Oswald-DemiBold", fontSize: "40px", color: "#FFF900"});
        unBreakableBlocksLabel.setOrigin(0.5);
        unBreakableBlocksLabel.scaleY = GameVars.scaleY;
        unBreakableBlocksLabel.scaleX = GameVars.scaleY;

        this.levelsRail.add(breakableBlocksLabel);

        for (let i = 0; i < 10; i++) {
            for (let j = 0; j < 18; j++) {

                n = 10 * j + i;

                if (n <=  25) {
                    let btn = new DevLevelButton(this, n, 3);
                    btn.x = GameConstants.GAME_WIDTH / 2 + (i - 4.5) * 60;
                    btn.y = (790 + 50 * j) / GameVars.scaleY;
                    this.levelsRail.add(btn);
                }
            }
        }

        const mixtBlocksLabel = this.add.text(GameConstants.GAME_WIDTH * 0.5, 730 * GameVars.scaleY, "Breakable Blocks",{ fontFamily: "Oswald-DemiBold", fontSize: "40px", color: "#FFF900"});
        mixtBlocksLabel.setOrigin(0.5);
        mixtBlocksLabel.scaleY = GameVars.scaleY;
        mixtBlocksLabel.scaleX = GameVars.scaleY;

        this.levelsRail.add(mixtBlocksLabel);

        const mainMenuButton = new Button(this, 50, 60 * GameVars.scaleY, "texture_atlas_1", "btn_back", "btn_back_hover", true);
        mainMenuButton.scaleY = GameVars.scaleY;
        mainMenuButton.onDown(this.onClickMainMenuButton, this);
        this.add.existing(mainMenuButton);
    }

    private onClickMainMenuButton(): void {
        
        GameManager.enterSplashScene();
    }

}
